<template>
  <section v-show="isVisible()">
    <slot></slot>
  </section>
</template>
<script>
export default {
  props: {
    label: String,
  },
  mounted() {
    this.$parent.registerTab(this.label);
  },
  methods: {
    isVisible() {
      return this.$parent.isSelected(this.label);
    },
  },
};
</script>
